import React from 'react';
import { Data } from '@styled-icons/boxicons-regular';
import { PlateRenderElementProps, PlateRenderLeafProps } from '@udecode/plate-core';
import { DreamValue } from '@typedream/core';
import styled, { css } from 'styled-components';
import { BLOCK_ELEMENT_KEY, CollectionDataKeys } from './types';
import { getTPlugin, useTPlateEditorRef } from '../../../../plate';
import { CollectionDataPluginOptions } from '../../types';
import { KEY_COLLECTION_CONNECT_DATA } from '../../../../pluginKeys';

const ConnectedStyle = css`
  background-color: var(--highlight-2);
  border: 1px solid var(--border-modal-transparent);
  padding: 0px 0px;
  border-radius: 2px;
`;
const SpanWrapper = styled.span<{ connected: boolean }>`
  ${(props) => props.connected && ConnectedStyle}
`;

const SpanTag = styled.span`
  padding: 2px 5px;
  font-size: 15px !important;
  margin-top: -2px;
  color: var(--text-lighter) !important;
  background-color: var(--background-highlight);
  border-radius: 2px;
  margin-right: 2px;
  line-height: inherit;
  vertical-align: middle;
  user-select: none !important;
  -webkit-user-select: none !important;
  font-weight: normal;
  letter-spacing: normal;
`;
// For showing that this block is connected to a data source
function CollectionDataElement(
  props: PlateRenderElementProps<DreamValue, CollectionDataKeys> &
  PlateRenderLeafProps<DreamValue, CollectionDataKeys>,
) {
  const editor = useTPlateEditorRef();
  const { options } = getTPlugin<CollectionDataPluginOptions>(editor, KEY_COLLECTION_CONNECT_DATA);

  const { showSchema } = options as CollectionDataPluginOptions;
  const {
    attributes, children, leaf,
  } = props;
  const dataKey = leaf?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS] ? leaf?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS]?.filter((k) => k.blockElementKey === 'text') : [];

  return (
    <SpanWrapper
      {...attributes}
      connected={showSchema && !!leaf?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA]}
    >
      {showSchema && leaf?.[BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA] ? (
        <SpanTag
          contentEditable={false}
          style={{
            userSelect: 'none',
          }}
        >
          <Data size={13} />
          {dataKey?.[0]?.schemaKey}
        </SpanTag>
      ) : null}
      <span>
        {children}
      </span>
    </SpanWrapper>
  );
}

export default CollectionDataElement;
